import { Component, HostListener, OnInit } from '@angular/core';
import { InteserraResourcesModel } from 'src/Models/InteserraResourcesModel';
import { FilterModel } from 'src/Models/filterModel';
import { InteserraResourcesService } from 'src/Services/inteserra-resources.service';
import { Router } from '@angular/router';
import { CheckAuth } from 'src/Services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { ToolEnum } from 'src/Models/Common';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-admin-inteserra-resources',
  templateUrl: './admin-inteserra-resources.component.html',
  styleUrls: ['./admin-inteserra-resources.component.css']
})
export class AdminInteserraResourcesComponent implements OnInit {

  filterModel = new FilterModel();
  currentPage: number = 1;
  totalRecordCount: number = -1;

  listOfInteserraResources: InteserraResourcesModel[];
  listOfInteserraResourcesExport: InteserraResourcesModel[];

  isUserSystemAdmin: boolean = true;
  tokenKey: string = '';
  SelectedTool: string;

  isAscending: boolean = false
  upDowTitleCSS: string = '';
  upDowURLCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowIsIsAllowallAccessCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedDateCSS: string = '';
  upDowSortOrderCSS: string = '';

  productId: number = 1;
  deletedId: number = 0;
  isloading: boolean;
  openMenuIndex: number = -1;

  constructor(private readonly InteserraResourcesService: InteserraResourcesService,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('JSI Resources');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'SortOrder';
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.GetInteserraResourcesData();
  }

  GetInteserraResourcesData() {
    this.isloading = true;
    this.listOfInteserraResources = [];
    this.filterModel.IsExport = false;
    this.InteserraResourcesService.i360InteserraResourcesGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfInteserraResources = data['inteserraResourcesGet'];
          if (this.listOfInteserraResources != null) {
            if (this.listOfInteserraResources.length > 0) {
              this.totalRecordCount = this.listOfInteserraResources[0].totalRecordCount;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  keywordFilters($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    if ($event.target.value != "" && $event.target.value != null) {
      this.filterModel.whereCondition = $event.target.value;
    }
    else {
      this.filterModel.whereCondition = '';
    }
    this.GetInteserraResourcesData();
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetInteserraResourcesData();
  }

  sort(sortBy: any) {
    this.upDowTitleCSS = '';
    this.upDowIsActiveCSS = '';
    this.upDowIsIsAllowallAccessCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowModifiedDateCSS = '';
    this.upDowSortOrderCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "isActive") {
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "isAllowallAccess") {
        this.upDowIsIsAllowallAccessCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sortOrder") {
        this.upDowSortOrderCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "isActive") {
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "isAllowallAccess") {
        this.upDowIsIsAllowallAccessCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sortOrder") {
        this.upDowSortOrderCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetInteserraResourcesData();
  }

  addInteserraResources() {
    this.router.navigate(['admin/jsi360/JSIResources/manage']);
  }

  editData(id) {
    this.router.navigate(['admin/jsi360/JSIResources/manage/' + id])
  }

  setDeleteData(ids) {
    this.deletedId = ids;
  }

  deleteRecord(deletedId) {
    this.InteserraResourcesService.i360InteserraResourcesDelete(this.tokenKey, deletedId).subscribe(
      data => {
        this.deletedId = 0;
        if (data != null) {
          if (data['deletedId'] > 0) {
            this.GetInteserraResourcesData();
            this.toastr.success('Record deleted successfully.', 'Delete')
          }
        }
      },
      error => {
      }
    );
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportJSIResource() {
    this.isloading = true;
    this.listOfInteserraResourcesExport = [];
    this.filterModel.IsExport = true;
    this.InteserraResourcesService.i360InteserraResourcesGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfInteserraResourcesExport = data['inteserraResourcesGet'];
          if (this.listOfInteserraResourcesExport != null) {
            if (this.listOfInteserraResourcesExport.length > 0) {
              setTimeout(() => {
                this.DownloadJSIResource();
                this.isloading = false;
              }, 1000);
            }
            else {
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadJSIResource() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportJSi360JSIResources';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportJSi360JSIResources.xls");
  }
}
